// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1uE8Y","paramInput":"JobSimulator_paramInput__1D6uo","input":"JobSimulator_input__2CsiS"};